export enum RealtimeEventType {
  PaymentReceived = 'payment.received',
  DocumentProcessingChanged = 'document.processing.changed',
  TrustAccountStatusChanged = 'trust-account.status.changed',
  PaymentInstructionStatusChanged = 'payment-instruction.status.changed',
  PayoutInstructionStatusChanged = 'payout-instruction.status.changed',
  PayoutCompleted = 'payout.completed',
  SupplementaryDeclarationRevoked = 'supplementary-declaration.revoked',
  BuyerRemoved = 'buyer.removed',
  TrustAccountMembersChanged = 'trust-account.members.changed'
}
